import { render } from "./2.Products.vue?vue&type=template&id=0dfdd3c0&scoped=true"
import script from "./2.Products.vue?vue&type=script&lang=js"
export * from "./2.Products.vue?vue&type=script&lang=js"

import "./2.Products.vue?vue&type=style&index=0&id=0dfdd3c0&lang=css"
import "./2.Products.vue?vue&type=style&index=1&id=0dfdd3c0&scoped=true&lang=css"
import "./2.Products.vue?vue&type=style&index=2&id=0dfdd3c0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dfdd3c0"]])

export default __exports__